import { EligibilityConfig, Partner } from '@bybeam/platform-types';
import Markdown from '@platform-ui-common/components/Markdown/index.js';
import Message from '@platform-ui-common/components/Message/index.js';
import usePlaceholder from '@platform-ui-common/hooks/usePlaceholder.js';
import replacePlaceholders from '@platform-ui-common/utilities/placeholder.js';
import { DEFAULT_COPY } from '@platform-ui/eligibility/utils/constants.js';

interface EligibilityMessageProps {
  config: EligibilityConfig;
  eligible: boolean | undefined;
  partner: Partner;
}

export default function EligibilityMessage({
  config,
  eligible,
  partner,
}: EligibilityMessageProps): JSX.Element {
  if (eligible === undefined) return null;
  const placeholderSource = usePlaceholder();

  const eligibleMessage = replacePlaceholders(
    config?.message?.eligible ?? DEFAULT_COPY.message.eligible,
    placeholderSource,
  );
  const ineligibleMessage = replacePlaceholders(
    config?.message?.ineligible ?? DEFAULT_COPY.message.ineligible,
    placeholderSource,
  );

  return (
    <div className="pb-8 px-5 lg:px-8">
      <Message variant={eligible ? 'success' : 'error'}>
        <div className="flex flex-col gap-2">
          <Markdown tags={{ p: 'span' }}>{eligible ? eligibleMessage : ineligibleMessage}</Markdown>
        </div>
      </Message>
    </div>
  );
}
